module.exports = __webpack_public_path__ + "media/WebsiteJuki.20401a8f.webm";